import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getPasswordChange } from "../../selectors";
import { isPublicAuthPath } from "../../utils/authPortal";

const FORCE_PATH = "/force-password-change";

/**
 * Enforces the force-password-change flow for an already-authenticated user.
 *
 * When `/auth/me` reports `force_password_change` (surfaced into redux as
 * `passwordChangeRequired` by the auth saga / keepalive poll), this guard
 * redirects the user to the force-password-change screen and keeps them there
 * until they rotate their password (which clears the flag). It deliberately
 * skips public auth routes (invitation/setup) — those run their own
 * password-set step — and never bounces away from the force screen itself.
 *
 * Rendered once, high in the tree (inside the router), so it can observe any
 * route. It renders nothing.
 */
const ForcePasswordChangeGuard = () => {
  const passwordChangeRequired = useSelector(getPasswordChange);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (!passwordChangeRequired) return;
    if (isPublicAuthPath()) return;
    if (location.pathname === FORCE_PATH) return;
    history.replace(FORCE_PATH);
  }, [passwordChangeRequired, location.pathname, history]);

  return null;
};

export default ForcePasswordChangeGuard;
